import mitt from 'mitt';

const emitter = mitt();
const handlers = new Map();

// Vue 2'nin `$emit`'i gibi: bir dinleyicinin hatası (veya reddedilen promise'i) loglanır,
// diğer dinleyiciler ve emit eden kod çalışmaya devam eder (vue-event-bus davranışı).
function invokeHandler(eventName, handler, args) {
    try {
        const result = handler(...args);
        if (result && typeof result.then === 'function' && typeof result.catch === 'function') {
            result.catch(error => console.error(`Error in event handler for "${eventName}":`, error));
        }
    } catch (error) {
        console.error(`Error in event handler for "${eventName}":`, error);
    }
}

function forEachEvent(event, callback) {
    const events = Array.isArray(event) ? event : [event];
    events.forEach(callback);
}

const bus = {
    $on(event, handler) {
        forEachEvent(event, eventName => {
            const wrappedHandler = args => invokeHandler(eventName, handler, args);
            let eventHandlers = handlers.get(eventName);

            if (!eventHandlers) {
                eventHandlers = new Map();
                handlers.set(eventName, eventHandlers);
            }

            const wrappedHandlers = eventHandlers.get(handler) || [];
            wrappedHandlers.push(wrappedHandler);
            eventHandlers.set(handler, wrappedHandlers);
            emitter.on(eventName, wrappedHandler);
        });
    },
    $off(event, handler) {
        if (arguments.length === 0) {
            emitter.all.clear();
            handlers.clear();
            return;
        }

        forEachEvent(event, eventName => {
            if (!handler) {
                emitter.all.delete(eventName);
                handlers.delete(eventName);
                return;
            }

            const eventHandlers = handlers.get(eventName);
            const wrappedHandlers = eventHandlers && eventHandlers.get(handler);

            if (!wrappedHandlers) {
                return;
            }

            wrappedHandlers.forEach(wrappedHandler => emitter.off(eventName, wrappedHandler));
            eventHandlers.delete(handler);

            if (eventHandlers.size === 0) {
                handlers.delete(eventName);
            }
        });
    },
    $emit(event, ...args) {
        emitter.emit(event, args);
    }
};

// Bileşen örneği olmayan modüller (utils/modalService.js) aynı bus'ı buradan alır; `$bus` ile aynı nesnedir.
export { bus };

export default {
    install(appOrVue) {
        const globalProperties = appOrVue.config && appOrVue.config.globalProperties
            ? appOrVue.config.globalProperties
            : appOrVue.prototype;

        Object.defineProperty(globalProperties, '$bus', {
            get() {
                return bus;
            }
        });
    }
};
